import { ChevronDown as DownIcon } from "@piiqtechnologies/svg-icons";
import { PeekAutocomplete, PeekTextField, PeekTypography } from "@piiqtechnologies/ui-components";
import { useDebounce, useDiscoverSubjects, useError, useLoader } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
export const SubjectSearchSelector = ({ organizationId, value, onChange, placeholder = "Search community...", disabled = false, }) => {
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearchKey = useDebounce(searchKey, 500);
    const [fetchSubjects, subjectsData, subjectsLoading, subjectsError] = useDiscoverSubjects();
    useEffect(() => {
        setLoader(subjectsLoading, "subjectsSearchLoading");
        return () => setLoader(false, "subjectsSearchLoading");
    }, [subjectsLoading]);
    useEffect(() => {
        if (subjectsError) {
            setError(subjectsError === null || subjectsError === void 0 ? void 0 : subjectsError.message);
        }
    }, [subjectsError]);
    useEffect(() => {
        if (organizationId) {
            fetchSubjects({
                organizationId: organizationId.trim(),
                search: debouncedSearchKey || undefined,
                limit: 50,
            });
        }
    }, [organizationId, debouncedSearchKey]);
    // Reset search when organization changes
    useEffect(() => {
        setSearchKey("");
    }, [organizationId]);
    const subjectOptions = useMemo(() => {
        const options = (subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.subjects)
            ? subjectsData.subjects.map(({ _id, name, address, url }) => ({
                _id,
                name,
                address,
                url,
            }))
            : [];
        // Ensure the selected value is always in the options list
        if (value && !options.some((opt) => opt._id === value._id)) {
            return [value, ...options];
        }
        return options;
    }, [subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.subjects, value]);
    const handleSubjectSelection = (_event, subject) => {
        onChange(subject);
    };
    const handleInputChange = (_event, newInputValue, reason) => {
        if (reason === "input") {
            setSearchKey(newInputValue);
        }
    };
    const handleClose = () => {
        setSearchKey("");
    };
    return (React.createElement(PeekAutocomplete, { disabled: disabled || !organizationId, onChange: handleSubjectSelection, onInputChange: handleInputChange, onClose: handleClose, options: subjectOptions, loading: subjectsLoading, getOptionLabel: (option) => (option === null || option === void 0 ? void 0 : option.name) || "", value: value, isOptionEqualToValue: (option, val) => option._id === (val === null || val === void 0 ? void 0 : val._id), popupIcon: React.createElement(PeekTypography, { sx: { mt: "4px !important", mr: "4px !important" } },
            React.createElement(DownIcon, { height: 18, width: 18 })), clearIcon: null, sx: {
            ".MuiAutocomplete-input": { height: "100%", p: "2.5px 0 !important" },
        }, renderInput: (params) => (React.createElement(PeekTextField, Object.assign({}, params, { placeholder: placeholder, sx: {
                ".MuiInputBase-root": {
                    height: "100%",
                },
            } }))) }));
};
export default SubjectSearchSelector;
